<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext.js';
    import { flip } from 'svelte/animate';
    import { fly } from 'svelte/transition';
    import { melt } from '@melt-ui/svelte';
    import { cx } from '$lib/utils/cx';
    import type { ToastData } from '$components/Toast/ToastData';
    import { match } from 'ts-pattern';

    //const { toasts, useToast, rootAttrs, groupAttrs } = getContainer().toast();

    const { toaster } = getContainer();
    const {
        elements: { content, title, description, close },
        actions: { portal },
        states: { toasts },
    } = toaster();

    function getVariantClass(data: ToastData) {
        return match(data.type)
            .with('success', () => 'bg-green-50 text-green-900')
            .with('error', () => 'bg-red-50 text-red-900')
            .otherwise(() => 'bg-blue-50 text-blue-900');
    }

    function getActionClass(data: ToastData) {
        return match(data.type)
            .with('success', () => 'text-green-900')
            .with('error', () => 'text-red-900')
            .otherwise(() => 'text-blue-900');
    }
</script>

<div use:portal class="fixed right-0 top-0 z-toast m-4 flex flex-col items-end gap-2">
    {#each $toasts as { id, data } (id)}
        <div
            use:melt={$content(id)}
            animate:flip={{ duration: 500 }}
            in:fly={{ duration: 150, x: '100%' }}
            out:fly={{ duration: 150, x: '100%' }}
            class={cx('shadow-md rounded-xl', getVariantClass(data))}
        >
            <div
                class={cx(
                    'w-toast m-0 max-w-[calc(100vw-2rem)] px-8 py-8 flex flex-col gap-2',
                )}
            >
                {#if data.title}
                    <div class="flex items-center">
                        <h3 use:melt={$title(id)} class="font-bold flex-auto m-0 p-0">
                            {data.title}
                        </h3>

                        <button
                            use:melt={$close(id)}
                            class="rounded-full text-gray-800 bg-gray-800 opacity-50 hover:opacity-100 btn-reset shrink-0 w-[25px] h-[25px] text-11 flex items-center justify-center"
                        >
                            <i class="tnp tnp-cross text-white" />
                        </button>
                    </div>
                    {#if data.message != null}
                        <div use:melt={$description(id)}>
                            {data.message}
                        </div>
                    {/if}
                {:else}
                    <div class="flex items-center">
                        {#if data.message != null}
                            <div use:melt={$description(id)} class="flex-auto">
                                {data.message}
                            </div>
                        {/if}
                        <button
                            use:melt={$close(id)}
                            class="rounded-full text-gray-800 bg-gray-800 opacity-50 hover:opacity-100 btn-reset shrink-0 w-[25px] h-[25px] text-11 flex items-center justify-center"
                        >
                            <i class="tnp tnp-cross text-white" />
                        </button>
                    </div>
                {/if}

                <div class="flex justify-end items-center gap-3">
                    {#each data.actions ?? [] as action}
                        <button
                            use:melt={$close(id)}
                            class={cx(
                                'bg-transparent font-bold border-none focus:outline-none cursor-pointer hover:underline',
                                getActionClass(data),
                            )}
                            on:click|preventDefault={() => action.action()}
                        >
                            {action.label}
                        </button>
                    {/each}
                </div>
            </div>
        </div>
    {/each}
</div>
